$(document).ready(function(){
	
	$(".faq-2024 .showhide").hide();
  $(".faq-2024 .showmore").show();

  /* FAQ */
  $('.faq-2024 .showmore').on('click', function(){
    $(this).next('.showhide').slideToggle();
    $(this).toggleClass('open');
  });
  
});